//@ts-nocheck
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../../../Layouts/Loader/Loader";
import PageHeader from "../../../../../Layouts/PageHeader/PageHeader";
import CatalogueService from "../../../../../service/CatalogueService";
import MissionService from "../../../../../service/MissionService";
import {
  MissionStore,
  setCloneTemplate,
  setIsCloneTemplateFalse,
  setIsCloneTemplateTrue,
  setSatellite,
} from "../../../../../store/MissionSlice";
import { usageStore } from "../../../../../store/UsageSlice";
import CloseButton from "../../../../CommonComponents/CloseButton";
import {
  calculateEdgeUsage,
  calculatePayloadUsage,
  calculateUsagePercentage,
  calculate_Total_AOP_Usage,
  eraseMissionData,
  navigateTo,
  navigateToWithState,
  showToastMessage,
} from "../../../../../utils/commonFunctions";
import SaveTemplate from "../../../../CommonComponents/SaveTemplate";
import BusSlider from "./BusSlider";
import Comm from "./Comm";
import Power from "./Power";
import PyloadServer from "./PyloadServer";
import FileUploader from "./FileUploader";
import CustomToolTip from "../../../../CommonComponents/CustomToolTip";
import './ModelUploader.scss'
import { AdcsSvg, BatterySvg, BranchSvg, CommsSvg, DbFileSvg, HammerSvg, ListSvg, PanelSvg, RedundancySvg, PayloadSSDSvg, GpsSvg, ThrusterSvg, PayloadObcSvg } from "./RedundancySvg";
import SatelliteModelUploader from "./SatelliteModelUploader";

const Bus = () => {
  const [hover, setHover] = useState(true);
  const [loading, setLoading] = useState(true)
  const [satelliteModelUploader, setSatelliteModelUploader] = useState(false);
  const [model, setModel] = useState({
    modelName: null,
    modelUrl: null,
    model: null
  })

  const [selectedComp, setSelectedComp] = useState('')
  const [selectedComp_UId, setSelectedComp_UId] = useState('')
  const [satName, setSatName] = useState("")


  const [espaTempData, setEspaTempData] = useState({
    type: '',
    value: '',
  })

  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { mission_name, sat_name, mission_id, sat_id, type, bus_name, bus_id } = params;
  const [satellieteDeta, setSatellieteData] = useState<any>({});

  const userData = useSelector((state: { mission: MissionStore }) => state.mission.userData);
  const flagSatelliteGroup = (userData?.['feature-allowed']?.['satelliteGroups'] && userData?.['feature-allowed']?.['satelliteGroups'] === 'Yes') ? true : false;
  const Satellite = useSelector(
    (state: { mission: MissionStore }) => state.mission.Satellite
  );

  const isBus = useSelector(
    (state: { mission: MissionStore }) => state.mission.bus.isBus
  );
  const isPayloadServer = useSelector(
    (state: { mission: MissionStore }) => state.mission.bus.isPayloadServer
  );
  const isComm = useSelector(
    (state: { mission: MissionStore }) => state.mission.bus.isComm
  );
  const isPower = useSelector(
    (state: { mission: MissionStore }) => state.mission.bus.isPower
  );

  const isCloneTemplate = useSelector(
    (state: { mission: MissionStore }) => state.mission.isCloneTemplate
  );
  const isNewTemplate = useSelector(
    (state: { mission: MissionStore }) => state.mission.isNewTemplate
  );
  const CloneTemplate = useSelector(
    (state: { mission: MissionStore }) => state.mission.CloneTemplate
  );
  const propulsion = useSelector(
    (state: { mission: MissionStore }) => state.mission.propulsion
  );

  const busSizeUsage = useSelector(
    (state: { usage: usageStore }) => state.usage.busSizeUsage
  );
  const payloadSizeUsage = useSelector(
    (state: { usage: usageStore }) => state.usage.payloadSizeUsage
  );
  const payloadPowerUsage = useSelector(
    (state: { usage: usageStore }) => state.usage.payloadPowerUsage
  );
  const payloadWeightUsage = useSelector(
    (state: { usage: usageStore }) => state.usage.payloadWeightUsage
  );
  const edgePowerUsage = useSelector(
    (state: { usage: usageStore }) => state.usage.edgePowerUsage
  );
  const edgeSizeUsage = useSelector(
    (state: { usage: usageStore }) => state.usage.edgeSizeUsage
  );
  const edgeWeightUsage = useSelector(
    (state: { usage: usageStore }) => state.usage.edgeWeightUsage
  );


  const [busConfig, setBusConfig] = useState({
    isBus: true,
    isPayloadServer: false,
    isComm: false,
    isPower: false,
  })

  const [busSlider, setBusSlider] = useState({
    busSliderSet: false,
    data: {},
    type: "",
    subSystem: "",
    numUnits: 0,
  })

  const closeBusSlider = () => {
    setSelectedComp('')
    setSelectedComp_UId('')
    setBusSlider({
      busSliderSet: false,
      data: {},
      type: "",
      subSystem: "",
      numUnits: 0,
    })
  }

  const enableBusSlider = (
    comp_data: any,
    comp_type: any,
    comp_subSystem: any,
    comp_numUnits: any
  ) => {
    setBusSlider({
      busSliderSet: true,
      data: comp_data,
      type: comp_type,
      subSystem: comp_subSystem,
      numUnits: comp_numUnits,
    })
  };

  const fetchModelUrl = async (satelliteId, modelName) => {
    try {
      const response = await MissionService.getModelUrl(satelliteId, modelName);
      if (response?.data) {
        setModel({ ...model, modelUrl: response?.data, modelName: modelName })
      } else {
        setModel({ ...model, modelUrl: null });
      }
    } catch (error) {
      setModel({ ...model, modelUrl: null });
      setLoading(false);
    }
  }

  const get_satellite = async () => {
    MissionService.get_satellite_by_sat_id(sat_id, mission_id)?.then((sat) => {
      if (sat?.data) {
        if (sat?.data?.modelNames?.modelName) {
          fetchModelUrl(sat_id, sat?.data?.modelNames?.modelName)
        }
        setSatName(sat?.data?.name)
        setSatellieteData(sat?.data)
        CatalogueService.getTemplate(type === 'clone_bus_design' ? bus_id : sat?.data?.templateId)?.then((template) => {
          if (template.data) {
            MissionService.get_payload_by_sat_id(sat_id, mission_id)?.then((payalod) => {
              MissionService.get_edge_by_sat_id(sat_id, mission_id)?.then((edge) => {
                const all_payloas = payalod?.data ? payalod?.data : []
                const all_edges = edge?.data ? edge?.data : []
                calculate_Total_AOP_Usage(all_payloas, all_edges, dispatch) //swap info calculation for power
                calculatePayloadUsage(all_payloas, dispatch) //swap info calculation for payloads
                calculateEdgeUsage(all_edges, dispatch) //swap info calculation for edge
                dispatch(setSatellite({
                  name: sat?.data?.['name'],
                  missionId: sat?.data?.missionId,
                  Payloads: all_payloas,
                  Edges: all_edges,
                  Template: template.data,
                  satellite_Id: sat_id,
                }))
                if (template?.data["template-attribute"]?.["type"] === 'espa') {
                  setEspaTempData({
                    type: template?.data["template-attribute"]?.["type"],
                    value: template?.data["template-attribute"]?.["sizeInXYZ"],
                  })
                } else {
                  setEspaTempData({
                    type: '',
                    value: '',
                  })
                }

                setLoading(false)
              }).catch((err) => {
                showToastMessage('error', "Error in getting edge")
                setLoading(false)
              })
            }).catch((err) => {
              showToastMessage('error', "Error in getting payloads")
              setLoading(false)
            })
          }
        }).catch((err) => {
          console.error(err);
          setLoading(false)
        })
      }
    }).catch((err) => {
      console.error(err);
      setLoading(false)
    })
  }

  useEffect(() => {
    if (type === "clone_bus_design") {
      dispatch(setIsCloneTemplateTrue())
    }
    if (sat_id) {
      get_satellite()
    }
  }, [sat_id])

  useEffect(() => {
    if (Satellite?.Template && Object.keys(Satellite?.Template).length > 0) {
      const allParams = {
        temp: Satellite?.Template,
        templateDataAvailable: true,
        dispatch: dispatch,
        powerUsage: payloadPowerUsage,
        edgePowerUsage: edgePowerUsage,
        edgeSizeUsage: edgeSizeUsage,
        edgeWeightUsage: edgeWeightUsage,
        sizeUsage: payloadSizeUsage,
        weightUsage: payloadWeightUsage
      }
      calculateUsagePercentage(allParams);
    }

  }, [Satellite?.Template, payloadPowerUsage, edgePowerUsage])

  const navigateToPreviewPage = () => {
    navigateTo(
      `${mission_name}/${mission_id}/${sat_name}/${sat_id}/review_satellite`,
      navigate
    );
  };

  const navigateToTemplate = () => {
    navigateTo(
      `${mission_name}/${mission_id}/${sat_name}/${sat_id}/add_new_template`,
      navigate
    );
    dispatch(setIsCloneTemplateFalse())
    dispatch(setCloneTemplate({}));
  };

  const update_satellite = (tempId) => {
    let sat = {
      ...satellieteDeta,
      versions: [
        {
          assembly: {
            'Payloads': satellieteDeta?.['versions']?.[0]?.['assembly']?.['Payloads'],
            'Edge': satellieteDeta?.['versions']?.[0]?.['assembly']?.['Edge'],
            'Template': tempId,
          },
        },
      ],
    };
    MissionService.update_satellites(sat_id, sat)?.then((res) => {
      if (res.data) {
        get_satellite()
      }
    }).catch((err) => {
      showToastMessage('error', "Something went wrong while updating Satellite");
    });
  }

  const save_satellites = () => {
    eraseMissionData(dispatch)
    const satelliteMode = sessionStorage.getItem('satelliteMode')
    const successMessage = `Satellite ${flagSatelliteGroup ? 'group' : ''} ${satelliteMode} successfully`;
    navigateToWithState(
      `${mission_name}/_details/${mission_id}/Satellites`,
      navigate,
      { SatelliteSuccessMessage: successMessage }
    );
  };

  const busSize = Satellite?.Template?.['template-attribute']?.['sizeInUnits']
  const bus_type = Satellite?.Template?.['template-attribute']?.['bus-type']
  const show_redundancy_icon = bus_type !== '3U' && bus_type !== '6U' && bus_type !== '12U' && bus_type !== '16U'


  return (
    <>
      <div className={`h-100 w-100 bus-main-wrapper ${satelliteModelUploader ? 'blur-active' : ''}`}>
        {loading && <Loader className="h-100 w-100" />}
        <div className="navigator-btn gap-3">
          {type === "configure" && <CloseButton />}
          {type === "view" &&
            <Button
              variant="outline-danger"
              type="button"
              className="d-flex align-items-center btn-outline-danger pt-1 pb-1 pe-5 ps-4 fs-14 "
              onClick={() => {
                eraseMissionData(dispatch)
                // navigateTo(`${mission_name}/${mission_id}/Satellites`, navigate)
                navigateTo(`${mission_name}/_details/${mission_id}/${'Satellites'}`, navigate)
              }}
            >
              <i className="fe fe-x me-1 fs-16"></i>
              Close
            </Button>
          }

          {(isCloneTemplate || isNewTemplate) && (
            <div className="btn-group btn-grp-nav">
              <Button
                variant={hover ? "outline-primary" : "primary"}
                type="button"
                className={`d-flex align-items-center btn ${hover ? "btn-outline-primary" : "btn-primary"
                  } pt-1 pb-1 pe-5 ps-6 fs-14`}
                onClick={navigateToTemplate}
                onMouseEnter={() => {
                  setHover(false);
                }}
                onMouseLeave={() => {
                  setHover(true);
                }}
              >
                <i className="fe fe-chevron-left me-1 fs-16"></i> Cancel
              </Button>
              <SaveTemplate hover={hover} navigateToTemplate={navigateToTemplate} setLoading={setLoading} bus_name={bus_name} />
            </div>
          )}
          {(type && type === 'configure') && <div>
            {!isCloneTemplate && !isNewTemplate && (
              <div className="btn-group btn-grp-nav">
                <Button
                  variant={hover ? "outline-primary" : "primary"}
                  type="button"
                  className={`d-flex align-items-center btn ${hover ? "btn-outline-primary" : "btn-primary"
                    } pt-1 pb-1 pe-5 ps-6 fs-14`}
                  onClick={navigateToPreviewPage}
                  onMouseEnter={() => {
                    setHover(false);
                  }}
                  onMouseLeave={() => {
                    setHover(true);
                  }}
                >
                  <i className="fe fe-chevron-left me-1 fs-16"></i> Back
                </Button>
                <Button
                  variant={hover ? "primary" : "outline-primary"}
                  type="button"
                  className={`d-flex align-items-center btn ${hover ? "btn-primary" : "btn-outline-primary"
                    } pt-1 pb-1 pe-5 ps-4 fs-14`}
                  onClick={save_satellites}
                >
                  Save Satellite
                  <i className="fe fe-chevron-right ms-1 fs-16"></i>
                </Button>
              </div>
            )}
          </div>}
        </div>

        <div className="configurator-nav top-100px z-2">
          <div className="config-menu d-flex flex-column gap-2">
            <div
              className={busConfig?.['isBus'] ? "config-item-link active" : "config-item-link"}
              onClick={() => {
                closeBusSlider();
                // if(type === 'clone_bus_design'){
                //   dispatch(setIsCloneTemplateTrue())
                // }
                setBusConfig({
                  isBus: true,
                  isPayloadServer: false,
                  isComm: false,
                  isPower: false,
                })
              }}
            >
              <span>
                <ListSvg />
              </span>
              <span>Bus</span>
            </div>
            <div
              className={
                busConfig?.['isPayloadServer'] ? "config-item-link active" : "config-item-link"
              }
              onClick={() => {
                closeBusSlider();
                // if(type === 'clone_bus_design'){
                //   dispatch(setIsCloneTemplateTrue())
                // }
                setBusConfig({
                  isBus: false,
                  isPayloadServer: true,
                  isComm: false,
                  isPower: false,
                })
              }}
            >
              <span>
                <DbFileSvg />
              </span>
              {type !== 'clone_bus_design' && <span>Payloads <br /> & Edge</span>}
              {type === 'clone_bus_design' && <span>Payload <br /> Server</span>}
            </div>
            <div
              className={busConfig?.['isComm'] ? "config-item-link active" : "config-item-link"}
              onClick={() => {
                closeBusSlider();

                setBusConfig({
                  isBus: false,
                  isPayloadServer: false,
                  isComm: true,
                  isPower: false,
                })
              }}
            >
              <span>
                <CommsSvg />
              </span>
              <span>Comm.</span>
            </div>
            <div
              className={busConfig?.['isPower'] ? "config-item-link active" : "config-item-link"}
              onClick={() => {
                closeBusSlider();
                // if(type === 'clone_bus_design'){
                //   dispatch(setIsCloneTemplateTrue())
                // }
                setBusConfig({
                  isBus: false,
                  isPayloadServer: false,
                  isComm: false,
                  isPower: true,
                })
              }}
            >
              <span>
                <BatterySvg />
              </span>
              <span>Power</span>
            </div>
          </div>
        </div>
        <PageHeader
          sat_name={isCloneTemplate ? '' : satName}
          titles={isCloneTemplate ? "Create New Bus Design" : "View your Satellite"}
          description={isCloneTemplate ? 'Create your Bus Design' : "View your configured satellite"}
          showSwap={((type === 'configure' || type === 'view') && Object.keys(Satellite)?.length > 0) ? true : false}
          showPercent={true}
          type={espaTempData?.['type']}
          value={espaTempData?.['value']}
        />
        <div className="d-flex overflow-y-auto">
          {busSizeUsage !== 0 && <div className="d-flex w-100">
            <div className="configurator-box w-50 position-relative">
              {busConfig?.['isBus'] && (
                <div className="config-data-box h-100">
                  <div
                    className={`config-card ${selectedComp === 'Bus OBC' && 'active'}`}
                    onClick={() => {
                      // if (type === "clone_bus_design") {
                      //   dispatch(setIsCloneTemplateTrue())
                      // }
                      setSelectedComp('Bus OBC')
                      enableBusSlider(
                        CloneTemplate?.["Core"]?.["Bus OBC"]
                          ? CloneTemplate?.["Core"]?.["Bus OBC"]
                          : Satellite.Template?.["assembly"]?.[0]?.["core"]?.["Bus OBC"]?.[
                          "atmos-data"
                          ],
                        "Bus OBC",
                        "Core",
                        Satellite.Template?.["assembly"]?.[0]?.["core"]?.["Bus OBC"]?.[
                        "user_data"
                        ]?.["numUnits"]
                      );
                    }}
                  >
                    <div className="w-100 d-flex align-item-center justify-content-between">
                      <h5 className="c-color1">
                        <span className="me-2">
                          <PanelSvg />
                        </span>
                        Bus OBC
                      </h5>
                      {show_redundancy_icon &&
                        <CustomToolTip placement="top" title="Redundant device available">
                          <RedundancySvg />
                        </CustomToolTip>
                      }
                    </div>
                    <div className="text-truncate">
                      <span className="me-2 ms-1">
                        <HammerSvg />
                      </span>
                      <CustomToolTip title={CloneTemplate?.["Core"]?.["Bus OBC"] ? CloneTemplate?.["Core"]?.["Bus OBC"]["name"] : Satellite.Template?.["assembly"]?.[0]?.["core"]?.["Bus OBC"]?.["atmos-data"]?.["name"]} placement="top-start">
                        {CloneTemplate?.["Core"]?.["Bus OBC"] ? CloneTemplate?.["Core"]?.["Bus OBC"]["name"] : Satellite.Template?.["assembly"]?.[0]?.["core"]?.["Bus OBC"]?.["atmos-data"]?.["name"]}
                      </CustomToolTip>
                    </div>
                    <div className="text-truncate">
                      <span className="me-2 ms-1">
                        <BranchSvg />
                      </span>
                      <CustomToolTip title={CloneTemplate?.["Core"]?.["Bus OS"] ? CloneTemplate?.["Core"]?.["Bus OS"]?.["name"] : Satellite.Template?.["assembly"]?.[0]?.["core"]?.["Bus OS"]?.["atmos-data"]?.["name"]} placement="top-start">
                        {CloneTemplate?.["Core"]?.["Bus OS"] ? CloneTemplate?.["Core"]?.["Bus OS"]?.["name"] : Satellite.Template?.["assembly"]?.[0]?.["core"]?.["Bus OS"]?.["atmos-data"]?.["name"]}
                      </CustomToolTip>
                    </div>
                  </div>

                  <div
                    className={`config-card ${selectedComp === 'ADCS' && 'active'}`}
                    onClick={() => {
                      setSelectedComp('ADCS')
                      enableBusSlider(
                        (CloneTemplate?.["Core"]?.["ADCS"] ||
                          CloneTemplate?.["Core"]?.["iADCS"]) &&
                          CloneTemplate?.["Core"]?.["adcsType"]
                          ? CloneTemplate?.["Core"]?.["adcsType"] === "Integrated"
                            ? CloneTemplate?.["Core"]?.["iADCS"]
                            : CloneTemplate?.["Core"]?.["ADCS"]
                          : Satellite.Template?.["template-attribute"]?.["ADCS"] === "iADCS"
                            ? Satellite.Template?.["assembly"]?.[0]?.["iADCS"]?.["atmos-data"]
                            : Satellite.Template?.["assembly"]?.[0]?.["core"]?.["ADCS"],
                        CloneTemplate?.["Core"]?.["adcsType"]
                          ? CloneTemplate?.["Core"]?.["adcsType"] === "Integrated"
                            ? "iADCS"
                            : "ADCS"
                          : Satellite.Template?.["template-attribute"]?.["ADCS"],
                        "Core",
                        0
                      );
                    }
                    }
                  >
                    <div className="w-100 d-flex align-item-center justify-content-between">
                      <h5 className="c-color1">
                        <span className="me-2">
                          <AdcsSvg />
                        </span>
                        ADCS
                      </h5>
                    </div>
                    <div className="text-truncate">
                      <span className="me-2 ms-1">
                        <HammerSvg />
                      </span>
                      <CustomToolTip title={(CloneTemplate?.["Core"]?.["ADCS"] || CloneTemplate?.["Core"]?.["iADCS"]) && CloneTemplate?.["Core"]?.["adcsType"] ? CloneTemplate?.["Core"]?.["adcsType"] === "Integrated" ? CloneTemplate?.["Core"]?.["iADCS"]?.["name"] : "Discrete" : Satellite.Template?.["template-attribute"]?.["ADCS"] === "iADCS" ? Satellite.Template?.["assembly"]?.[0]?.["iADCS"]?.["atmos-data"]?.["name"] : "Discrete"} placement="top-start">
                        {(CloneTemplate?.["Core"]?.["ADCS"] || CloneTemplate?.["Core"]?.["iADCS"]) && CloneTemplate?.["Core"]?.["adcsType"] ? CloneTemplate?.["Core"]?.["adcsType"] === "Integrated" ? CloneTemplate?.["Core"]?.["iADCS"]?.["name"] : "Discrete" : Satellite.Template?.["template-attribute"]?.["ADCS"] === "iADCS" ? Satellite.Template?.["assembly"]?.[0]?.["iADCS"]?.["atmos-data"]?.["name"] : "Discrete"}
                      </CustomToolTip>
                    </div>
                  </div>

                  <div
                    className={`config-card ${selectedComp === 'GPS' && 'active'}`}
                    onClick={() => {
                      setSelectedComp('GPS')
                      enableBusSlider(
                        CloneTemplate?.["Core"]?.["GPS"]
                          ? CloneTemplate?.["Core"]?.["GPS"]
                          : Satellite.Template?.["assembly"]?.[0]?.["core"]?.["GPS"]?.[
                          "atmos-data"
                          ],
                        "GPS",
                        "Core",
                        Satellite.Template?.["assembly"]?.[0]?.["core"]?.["GPS"]?.[
                        "user_data"
                        ]?.["numUnits"]
                      );
                    }}
                  >
                    <div className="w-100 d-flex align-item-center justify-content-between">
                      <h5 className="c-color1">
                        <span className="me-2">
                          <GpsSvg />
                        </span>
                        GPS
                      </h5>
                      {show_redundancy_icon &&
                        <CustomToolTip placement="top" title="Redundant device available">
                          <RedundancySvg />
                        </CustomToolTip>
                      }
                      {/* <span className="h-1 w-1 border"></span> */}
                    </div>

                    <div className="text-truncate">
                      <CustomToolTip title={CloneTemplate?.["Core"]?.["GPS"] ? CloneTemplate?.["Core"]?.["GPS"]["name"] : Satellite.Template?.["assembly"]?.[0]?.["core"]?.["GPS"]?.["atmos-data"]?.["name"]} placement="top-start">
                        {CloneTemplate?.["Core"]?.["GPS"] ? CloneTemplate?.["Core"]?.["GPS"]["name"] : Satellite.Template?.["assembly"]?.[0]?.["core"]?.["GPS"]?.["atmos-data"]?.["name"]}
                      </CustomToolTip>
                    </div>
                  </div>

                  {(Satellite.Template?.["assembly"]?.[0]?.["core"]?.["Thruster"] && (Satellite.Template?.["template-attribute"]?.["propulsion"] === "Yes" ||
                    propulsion === "Yes")) && (
                      <div
                        className={`config-card ${selectedComp === 'Thruster' && 'active'}`}
                        onClick={() => {
                          setSelectedComp('Thruster')
                          enableBusSlider(
                            CloneTemplate?.["Core"]?.["Thruster"]
                              ? CloneTemplate?.["Core"]?.["Thruster"]
                              : Satellite.Template?.["assembly"]?.[0]?.["core"]?.[
                              "Thruster"
                              ]?.["atmos-data"],
                            "Thruster",
                            "Core",
                            CloneTemplate?.["Core"]?.["Thruster"]
                              ? CloneTemplate?.["Core"]?.["ThrusterCount"]
                              : Satellite.Template?.["assembly"]?.[0]?.["core"]?.[
                              "Thruster"
                              ]?.["user_data"]?.["numUnits"]
                          );

                        }}
                      >
                        <div className="w-100 d-flex align-item-center justify-content-between">
                          <h5 className="c-color1">
                            <span className="me-2">
                              <ThrusterSvg />
                            </span>
                            Thruster
                          </h5>
                          {/* <span className="h-1 w-1 border"></span> */}
                        </div>
                        <div className='text-truncate'>
                          <CustomToolTip title={CloneTemplate?.["Core"]?.["Thruster"] ? CloneTemplate?.["Core"]?.["Thruster"]["name"] : Satellite.Template?.["assembly"]?.[0]?.["core"]?.["Thruster"]?.["atmos-data"]?.["name"]} placement="top-start">
                            {CloneTemplate?.["Core"]?.["Thruster"] ? CloneTemplate?.["Core"]?.["Thruster"]["name"] : Satellite.Template?.["assembly"]?.[0]?.["core"]?.["Thruster"]?.["atmos-data"]?.["name"]}
                          </CustomToolTip>
                        </div>
                      </div>
                    )}

                  <div className={`config-card ${selectedComp === 'Payload OBC' && 'active'}`}
                    onClick={() => {
                      setSelectedComp('Payload OBC')
                      setSelectedComp_UId('Payload OBC')
                      enableBusSlider(CloneTemplate?.['Payload']?.['Payload OBC'] ? CloneTemplate?.['Payload']?.['Payload OBC'] : Satellite?.Template?.['assembly']?.[0]?.['payloadServer']?.['Payload OBC']?.['atmos-data'], 'Payload OBC', 'Payload Server', Satellite?.Template?.['assembly']?.[0]?.['payloadServer']?.['Payload OBC']?.['user_data']?.['numUnits'])
                    }}>
                    <div className="d-flex align-items-start justify-content-between">
                      <h5 className="c-color1">
                        <span className="me-2">
                          <PayloadObcSvg />
                        </span>
                        Payload OBC
                      </h5>
                      {show_redundancy_icon &&
                        <CustomToolTip placement="top" title="Redundant device available">
                          <RedundancySvg />
                        </CustomToolTip>
                      }
                    </div>
                    <div className="text-truncate">
                      <CustomToolTip title={CloneTemplate?.['Payload']?.['Payload OBC'] ? CloneTemplate?.['Payload']?.['Payload OBC']?.['name'] : Satellite?.Template?.['assembly']?.[0]?.['payloadServer']?.['Payload OBC']?.['atmos-data']?.['name']} placement="top-start">
                        {CloneTemplate?.['Payload']?.['Payload OBC'] ? CloneTemplate?.['Payload']?.['Payload OBC']?.['name'] : Satellite?.Template?.['assembly']?.[0]?.['payloadServer']?.['Payload OBC']?.['atmos-data']?.['name']}
                      </CustomToolTip>
                    </div>
                  </div>

                  <div className={`config-card ${selectedComp === 'Payload SSD' && 'active'}`}
                    onClick={() => {
                      setSelectedComp('Payload SSD')
                      setSelectedComp_UId('Payload SSD')
                      enableBusSlider(CloneTemplate?.['Payload']?.['Payload SSD'] ? CloneTemplate?.['Payload']?.['Payload SSD'] : Satellite?.Template?.['assembly']?.[0]?.['payloadServer']?.['Payload SSD']?.['atmos-data'], 'Payload SSD', 'Payload Server', (CloneTemplate?.['Payload']?.['Payload SSDCount'] ? CloneTemplate?.['Payload']?.['Payload SSDCount'] : Satellite?.Template?.['assembly']?.[0]?.['payloadServer']?.['Payload SSD']?.['user_data']?.['numUnits']))
                    }}>
                    <div className="d-flex align-items-start justify-content-between">
                      <h5 className="c-color1">
                        <span className="me-2">
                          <PayloadSSDSvg />
                        </span>
                        Payload SSD
                      </h5>
                      {show_redundancy_icon &&
                        <CustomToolTip placement="top" title="Redundant device available">
                          <RedundancySvg />
                        </CustomToolTip>
                      }
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span className="w-95 text-truncate">
                        <CustomToolTip title={CloneTemplate?.['Payload']?.['Payload SSD'] ? CloneTemplate?.['Payload']?.['Payload SSD']?.['name'] : Satellite?.Template?.['assembly']?.[0]?.['payloadServer']?.['Payload SSD']?.['atmos-data']?.['name']} placement="top-start">
                          {CloneTemplate?.['Payload']?.['Payload SSD'] ? CloneTemplate?.['Payload']?.['Payload SSD']?.['name'] : Satellite?.Template?.['assembly']?.[0]?.['payloadServer']?.['Payload SSD']?.['atmos-data']?.['name']}
                        </CustomToolTip>
                      </span>
                      ({CloneTemplate?.['Payload']?.['Payload SSDCount'] ? CloneTemplate?.['Payload']?.['Payload SSDCount'] : Satellite?.Template?.['assembly']?.[0]?.['payloadServer']?.['Payload SSD']?.['user_data']?.['numUnits']})
                    </div>
                  </div>


                </div>
              )}
              {busConfig?.['isPayloadServer'] &&
                <PyloadServer
                  selectedComp={selectedComp}
                  setSelectedComp={setSelectedComp}
                  selectedComp_UId={selectedComp_UId}
                  setSelectedComp_UId={setSelectedComp_UId}
                  enableBusSlider={enableBusSlider}
                />
              }
              {busConfig?.['isComm'] &&
                <Comm
                  selectedComp={selectedComp}
                  setSelectedComp={setSelectedComp}
                  enableBusSlider={enableBusSlider}
                />
              }
              {busConfig?.['isPower'] &&
                <Power
                  selectedComp={selectedComp}
                  setSelectedComp={setSelectedComp}
                  enableBusSlider={enableBusSlider}
                />
              }
            </div>
            {!loading && <div
              style={{
                height: "80vh",
                width: "50%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                top: '130px',
              }}
            >
              {
                <FileUploader
                  Satellite={Satellite}
                  busSizeUsage={busSizeUsage}
                  payloadSizeUsage={payloadSizeUsage}
                  isCloneTemplate={isCloneTemplate}
                  mainLoading={loading}
                  satelliteModelUploader={satelliteModelUploader}
                  setSatelliteModelUploader={setSatelliteModelUploader}
                  model={model}
                  setModel={setModel}
                />
              }
            </div>}
          </div>}
        </div>
        {busSlider.busSliderSet && <BusSlider closeBusSlider={closeBusSlider} busSlider={busSlider} />}

      </div>
      {satelliteModelUploader &&
        <SatelliteModelUploader
          busSize={busSize}
          setSatelliteModelUploader={setSatelliteModelUploader}
          model={model}
          setModel={setModel}
        />
      }
    </>
  );
};
export default Bus;
